<template>
  <button
    class="viewer-fullscreen-control"
    :class="{ 'viewer-fullscreen-control--inactive': inactive }"
    :aria-hidden="inactive ? 'true' : undefined"
    aria-label="Fullscreen"
    :tabindex="inactive ? -1 : undefined"
    title="Fullscreen"
    type="button"
    @click="emit('click', $event)"
  >
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M7.5 1.5H10.5V4.5M4.5 10.5H1.5V7.5M10.5 1.5L7 5M1.5 10.5L5 7"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    inactive?: boolean;
  }>(),
  {
    inactive: false,
  }
);

const emit = defineEmits<{
  click: [event: MouseEvent];
}>();
</script>

<style scoped lang="scss">
.viewer-fullscreen-control {
  position: absolute;
  z-index: 10;
  right: var(--viewer-fullscreen-control-inset, 0.75rem);
  bottom: var(--viewer-fullscreen-control-inset, 0.75rem);
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--viewer-fullscreen-control-size, 1.75rem);
  height: var(--viewer-fullscreen-control-size, 1.75rem);
  border-radius: 0.375rem;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  transition:
    background-color 150ms ease,
    opacity 150ms ease;
}

.viewer-fullscreen-control:hover,
.viewer-fullscreen-control:focus-visible {
  background-color: rgba(0, 0, 0, 0.7);
}

.viewer-fullscreen-control:focus-visible {
  outline: 2px solid rgba(59, 130, 246, 0.8);
  outline-offset: 2px;
}

.viewer-fullscreen-control--inactive {
  pointer-events: none;
  opacity: 0;
}
</style>
